/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import "moment-timezone";
import moment from "moment-timezone";
import React, { useContext, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { CommonDateTime } from "../../Api/commonDateTime";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import ViewIcon from "../../assets/image/ViewIcon.svg";
import cross_for_viewcard from "../../assets/image/cross_for_viewcard.svg";
import ReusableTable from "../UserInformation/ReusableTable";
import DeleteConfirmModal from "../RecipientManagement/DeleteConfirmModal";
import { refundAPI } from "../../Api/apiService";
import { getOrderStatusColor } from "../../utils/common";

const ViewReport = () => {
  const { websocket } = useContext(WebSocketContext);
  const { OrderList, userList, search, userId, formDate, toDate, selfInfo } =
    useSelector((state) => state.adminReducers);
  const [currentPage, setCurrentPage] = useState(1);
  const { id } = useParams();

  const [viewModal, setViewModel] = useState({
    open: false,
    data: null,
  });
  const handleOpen = (data) => {
    setViewModel({ open: true, data });
  };
  const handleClose = () => {
    setViewModel({ open: false, data: null });
  };
  const [removeModal, setRemoveModal] = useState({
    open: false,
    order: null,
  });
  const confirmRemove = async () => {
    const payload = {
      referenceId: removeModal.order.reference_id,
      dstatusOrderId: removeModal.order.dstatus_order_id
        ? removeModal.order.dstatus_order_id
        : null,
    };
    let url = "";
    if (removeModal.order.user_code === "arvdn_user") {
      url = "arvdnqrapi/refund";
    } else if (removeModal.order.user_code === "eShop2_offline_user") {
      url = "eshop2/offline/refund";
    } else if (removeModal.order.user_code === "eShop2_online_user") {
      url = "eshop2/online/refund";
    }
    await refundAPI(payload, url);
    setRemoveModal({ open: false, order: removeModal.order });
    let param = {
      transmit: "single",
      url: "order_list",
      request: {
        status: [
          "Success",
          "SUCCESS",
          "Failed",
          "FAILED",
          "PAID",
          "Paid",
          "TBC",
        ],
        limit: "20",
        page_no: search ? 1 : currentPage,
        search: search ? search : "",
        user_id: userId ? userId : "",
        order_by: "-updated_at",
        machine_id: id,
      },
    };
    wsSend_request(websocket, param);
  };

  const closeRemoveModal = () => {
    setRemoveModal({ open: false, order: null });
  };

  const NON_REFUNDABLE_ACQUIRERS = [
    "fpx",
    "FPX_BIMB",
    "FPX_MB2U",
    "FPX_PBB",
    "FPX_CIMBCLICKS",
    "FPX_AMB",
    "FPX_HLB",
    "FPX_RHB",
    "FPX_OCBC",
    "FPX_SCB",
    "FPX_ABB",
    "FPX_BKRM",
    "FPX_BMMB",
    "FPX_KFH",
    "FPX_BSN",
    "FPX_ABMB",
    "FPX_UOB",
    "FPX_HSBC",
    "FPX_AGROBANK",
    "FPX_BOCM",
    "FPX_B2B_AMB",
    "FPX_B2B_HLB",
    "FPX_B2B_UOB",
    "FPX_B2B_ABB",
    "FPX_B2B_CIMB",
    "FPX_B2B_BIMB",
    "FPX_B2B_PBB",
    "FPX_B2B_RHB",
    "FPX_B2B_HSBC",
    "FPX_M2E",
    "FPX_B2B_BNP",
    "FPX_B2B_ABBM",
    "FPX_B2B_CITIBANK",
    "FPX_B2B_BKRM",
    "FPX_B2B_PBBE",
    "FPX_B2B_UOBR",
    "FPX_B2B_AGROBANK",
    "FPX_EMANDATE",
    "FPX_EMANDATE_ABB",
  ];

  useEffect(() => {
    let param = {
      transmit: "single",
      url: "order_list",
      request: {
        status: [
          "Success",
          "SUCCESS",
          "Failed",
          "FAILED",
          "PAID",
          "Paid",
          "TBC",
        ],
        limit: "20",
        page_no: search ? 1 : currentPage,
        search: search ? search : "",
        user_id: userId ? userId : "",
        order_by: "-updated_at",
        machine_id: id,
      },
    };
    if (formDate && toDate) {
      param.request.from_date =
        CommonDateTime(formDate, "YYYY-MM-DD", "hide") +
        " " +
        CommonDateTime(formDate, "HH:mm", "show");
      const formattedToDate =
        CommonDateTime(toDate, "YYYY-MM-DD", "hide") +
        " " +
        (CommonDateTime(toDate, "HH:mm", "show") === "00:00"
          ? "23:59"
          : CommonDateTime(toDate, "HH:mm", "show"));
      param.request.to_date = formattedToDate;
    }
    wsSend_request(websocket, param);
  }, [websocket, currentPage, userId, search, formDate, toDate]);
  const UserDetail = (id) => {
    const userInf = userList?.list?.filter((user) => user?.id === id)[0];
    return {
      userName: userInf?.username,
      useEmail: userInf?.email,
      mobileNUmber: userInf?.phone,
      user_code: userInf?.user_code,
    };
  };
  useEffect(() => {
    let param = {
      transmit: "single",
      url: "user_list",
      request: {
        status: true,
        limit: "10000000",
        page_no: 1,
        search: "",
        order_by: "-updated_at",
      },
    };
    wsSend_request(websocket, param);
  }, []);

  const currentFunction = (page) => {
    setCurrentPage(page);
  };
  const headers = [
    { name: "Date & Time", key: "dateTime" },
    ...(selfInfo?.user_type === "super_admin"
      ? [{ name: "Recipient Name", key: "recipient_name" }]
      : []),
    { name: "Machine ID", key: "machine_id" },
    { name: "Recipient Machine Name", key: "machine_name" },
    { name: "User Id", key: "user_id" },
    { name: "Order Id", key: "dstatusOrderId" },
    { name: "Transaction Id", key: "transactionId" },
    { name: "Amount", key: "amount" },
    { name: "Status", key: "status" },
    { name: "Payment Acquire API", key: "acquire_api" },
    { name: "Refund", key: "refund" },
    { name: "Detail", key: "detail" },
    { name: "Action", key: "action" },
  ];

  const renderRow = (order, index, visibleColumns) => {
    return (
      <React.Fragment key={order?.id}>
        <tr key={order?.id} className="user-management-table-detail">
          {visibleColumns?.includes("dateTime") && (
            <td style={{ cursor: "default" }} className="Vertical_align">
              {moment(order?.created_at).format("YYYY-MM-DD HH:mm:ss")}
            </td>
          )}
          {visibleColumns?.includes("recipient_name") && (
            <td className="Vertical_align">
              {order?.recipient_name ? order?.recipient_name : "-"}
            </td>
          )}
          {visibleColumns?.includes("machine_id") && (
            <td className="Vertical_align">
              {order?.machine_code ? order?.machine_code : "-"}
            </td>
          )}
          {visibleColumns?.includes("machine_name") && (
            <td className="Vertical_align">
              {order?.machine_name ? order?.machine_name : "-"}
            </td>
          )}
          {visibleColumns?.includes("user_id") && (
            <td className="Vertical_align">
              {order?.user_code ? order?.user_code : "-"}
            </td>
          )}
          {visibleColumns?.includes("dstatusOrderId") && (
            <td className="Vertical_align">
              {order.dstatus_order_id ? order.dstatus_order_id : "-"}
            </td>
          )}
          {visibleColumns?.includes("transactionId") && (
            <td className="Vertical_align">
              {order?.transaction_id ? order?.transaction_id : "-"}
            </td>
          )}
          {visibleColumns?.includes("amount") && (
            <td
              style={{ cursor: "default", color: "#1AA773" }}
              className="Vertical_align"
            >
              {parseFloat(order.total_amount).toFixed(2)}
            </td>
          )}
          {visibleColumns?.includes("mobileNumber") && (
            <td style={{ cursor: "default" }}>
              {UserDetail(order?.user_id)?.mobileNUmber || "-"}
            </td>
          )}
          {visibleColumns?.includes("status") && (
            <td style={{ cursor: "default" }}>
              <div
                style={{
                  padding: "4px 20px",
                  height: "26px",
                  textAlign: "center",
                  borderRadius: "4px",
                  color: "black",
                  backgroundColor: getOrderStatusColor(order.status),
                }}
              >
                {order.status === "PAID" ||
                order.status === "Paid" ||
                order.status === "Success"
                  ? "SUCCESS"
                  : order.status?.toUpperCase()}
              </div>
            </td>
          )}
          {visibleColumns?.includes("acquire_api") && (
            <td>{order?.payment_acquirer ? order?.payment_acquirer : "-"}</td>
          )}
          {visibleColumns?.includes("refund") && (
            <td className="Vertical_align">
              {(() => {
                const createdAt = new Date(order.created_at);
                const now = new Date();
                const diffInDays =
                  (now.getTime() - createdAt.getTime()) / (1000 * 60 * 60 * 24);

                const within7Days = diffInDays <= 7;

                const isChildEntry = Boolean(order.dstatus_order_id);
                const isParentEntry = !isChildEntry;

                const isAlreadyRefunded =
                  order?.refund_status?.toUpperCase() === "SUCCESS" || order?.refund_status?.toUpperCase() === "PENDING";

                const isOrderSuccessful = order?.status === "SUCCESS";

                const deliveryStatus = order?.items?.[0]?.delivery_status;

                const isDeliveryFailed = deliveryStatus === "FAILED";

                const isMultiVendingEligible = order?.status === "SUCCESS";

                const isSingleVendingEligible =
                  order?.status === "PAID" && deliveryStatus === "SUCCESS";

                const isNonRefundableAcquirer =
                  NON_REFUNDABLE_ACQUIRERS?.includes(order?.payment_acquirer);

                const canRefund =
                  isChildEntry &&
                  within7Days &&
                  !isNonRefundableAcquirer &&
                  !isAlreadyRefunded &&
                  !isDeliveryFailed &&
                  (isMultiVendingEligible || isSingleVendingEligible);
                return (
                  <div
                    onClick={
                      canRefund
                        ? () => setRemoveModal({ open: true, order })
                        : undefined
                    }
                    className={`refund_button ${
                      canRefund ? "active" : "disabled"
                    }`}
                    title={
                      isAlreadyRefunded
                        ? "Refund already completed"
                        : !within7Days
                          ? "Refund not available after 7 days"
                          : !isNonRefundableAcquirer
                            ? "Payment acquirer is not refundable"
                            : isDeliveryFailed
                              ? "Refund is auto-processed for failed delivery"
                              : !isOrderSuccessful
                                ? "Refund allowed only for successful orders"
                                : isParentEntry
                                  ? "Refund disabled for parent entry"
                                  : "Click to initiate refund"
                    }
                  >
                    Refund
                  </div>
                );
              })()}
            </td>
          )}
          {visibleColumns?.includes("detail") && (
            <td>
              <div className="d-flex">
                <span style={{ color: "black", marginLeft: "7px" }}>
                  {order?.refund_amount} RM Refunded
                </span>
              </div>
            </td>
          )}
          {visibleColumns?.includes("action") && (
            <td className="Vertical_align">
              <div
                onClick={() => handleOpen(order)}
                // onClick={() => openModel(order.id,order.total_amount)}
                style={{ width: "20px", height: "20px", cursor: "pointer" }}
              >
                <img src={ViewIcon} alt="ViewIcon" />
              </div>
            </td>
          )}
        </tr>
      </React.Fragment>
    );
  };
  return (
    <>
      <ReusableTable
        headers={headers}
        data={OrderList?.orders || []}
        paginationObject={OrderList?.pagination}
        renderRow={renderRow}
        filters={{
          fromDate: true,
          toDate: true,
          period: false,
          search: true,
          searchPlaceholder:
            selfInfo?.user_type === "super_admin"
              ? "Search by Recipient Name, Machine ID"
              : "Search by Machine ID",
          userSelect: false,
          userOptions: [],
          export: true,
          reset: true,
        }}
        currentPage={currentPage}
        handlePageChange={currentFunction}
      />
      {viewModal?.open && (
        <div className="modal d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content rounded-4"
              style={{
                width: "667px",
                margin: "auto",
                borderRadius: "17px",
                border: "none",
                boxShadow: "1px 1px 1px 0px #ffffff",
                background: "white",
                padding: "25px",
              }}
            >
              <div className="text-start">
                <div className="d-flex justify-content-between align-items-center border-bottom-df">
                  <h1 className="view_popup_title">View Details</h1>
                  <img
                    src={cross_for_viewcard}
                    alt="cross_for_viewcard"
                    className="cross_for_viewcard"
                    onClick={handleClose}
                  />
                </div>
                <div className="mt-4">
                  <Table>
                    <thead style={{ background: "#EFEFEFB2" }}>
                      <tr>
                        <th className="new_view_table_heading">Product ID</th>
                        <th className="new_view_table_heading">Product Name</th>
                        <th className="new_view_table_heading">Product Cost</th>
                      </tr>
                    </thead>
                    <tbody>
                      {viewModal?.data?.items &&
                      viewModal?.data?.items?.length > 0 ? (
                        viewModal?.data?.items?.map((item, index) => (
                          <tr key={index}>
                            <td
                              style={{ border: "1px solid #D5D1D1" }}
                              className="new_view_table_body_title"
                            >
                              {item.product_id}
                            </td>
                            <td
                              style={{ border: "1px solid #D5D1D1" }}
                              className="new_view_table_body_title"
                            >
                              {item.product_name}
                            </td>
                            <td
                              style={{ border: "1px solid #D5D1D1" }}
                              className="new_view_table_body_title"
                            >{`Rm ${item.amount}`}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={3}
                            className="text-center new_subheading"
                          >
                            Order detail is empty
                          </td>
                        </tr>
                      )}
                      {viewModal?.data?.items &&
                        viewModal?.data?.items?.length > 0 && (
                          <>
                            <tr>
                              <th
                                colSpan={2}
                                className="text-end new_subheading"
                                style={{ border: "1px solid #D5D1D1" }}
                              >
                                SubTotal
                              </th>
                              <td
                                style={{ border: "1px solid #D5D1D1" }}
                                className="new_view_table_body_title"
                              >{`Rm ${viewModal?.data?.total_amount}`}</td>
                            </tr>
                            <tr>
                              <th
                                colSpan={2}
                                className="text-end new_subheading"
                                style={{ border: "1px solid #D5D1D1" }}
                              >
                                Refund
                              </th>
                              <td
                                style={{ border: "1px solid #D5D1D1" }}
                                className="new_view_table_body_title"
                              >{`Rm ${viewModal?.data?.total_amount}`}</td>
                            </tr>
                          </>
                        )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {removeModal.open && (
        <DeleteConfirmModal
          open={removeModal.open}
          onClose={closeRemoveModal}
          onConfirm={confirmRemove}
          message="Are you sure you want to refund this order amount?"
          isSuccess={false}
          isDelete={false}
          isRequest={true}
          confirmText="Confirm"
          cancelText="Cancel"
        />
      )}
    </>
  );
};

export default ViewReport;
